/* global Blockly */
import React from 'react';
import { getPagesFromContext } from "../helpers";

function defineBlock(formPages) {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField("reload page")
                .appendField(new Blockly.FieldDropdown(formPages), "PAGE");
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Reload target page, triggering OnLoad events.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#app-actions");
        }
    }
}

function defineGenerators() {
    return {
        "JavaScript": function (block) {
            let pageDataGenyId = block.getFieldValue('PAGE').split('<<<>>>').slice(-1);
            let code = `navigationModule.reloadPage('${pageDataGenyId}');\n`;
            return code;
        }
    }
}

const ReloadPage = function (props) {
    let name = "snap_action_reloadpage";
    ReloadPage.blockName = name;

    const formPages = getPagesFromContext(props.context);

    Blockly.Blocks[name] = defineBlock(formPages);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return formPages.length > 0 ?
        <block type={name}></block>
        : null;
};

export default ReloadPage;
